  // PROCESSING
  function createCanvas() {
    var container = document.getElementById('sketch-container');
    var sketch = document.getElementById('sketch');
    sketch && container.removeChild(sketch);

    sketch = document.createElement('canvas');
    sketch.id = 'sketch';
    sketch.classList.add("sketch");    
    container.appendChild(sketch);
    // sketch.setAttribute("style", "border: 2px dashed #fff; outline: none;");

    return sketch;
  }

  function runSketch() {
    window.ki_starLoopTime = Date.now();
    var codeValue = window.editor.getValue();
    var lastChar = codeValue.slice(codeValue.length - 1);
    // console.log("-" + lastChar + "-");
    if (lastChar != "\n") codeValue += "\n";
    // codeValue = "size(300, 300)";
    // console.log('r:' + codeValue);
    try {
      var processingInstance = Processing.getInstanceById('sketch');
      if (processingInstance) {
        console.log('noLoop()');
        processingInstance.noLoop();
        processingInstance.exit();
      }

      var canvas = createCanvas();
      var sketch = Processing.compile(codeValue);

      // check for loop
      var injectedCheckFunction = 
      "function ki_khasangTimeCalc() {"
      + "  if (Date.now() - window.ki_starLoopTime > 100) {"
      // + "$('#mouseCoords').html(getRandomSadSmile() + 'Бесконечный цикл');"
      + "var ki_mc = document.getElementById('mouseCoords');"
      + "if(ki_mc) ki_mc.innerHTML = 'Бесконечный цикл';"
      // + "var mc = document.getElementById('mouseCoords');"
      // + "if (mc) mc.innerHTML = 'Бесконечный цикл'"
      + "    throw 'Бесконечный цикл';"
      + "  }"
      + "}";

      var injectedCheckFunctionCall = "ki_khasangTimeCalc();";      

      var words = sketch.sourceCode.split(/(while\s*\(.*\)\s*{)/g);
      
      if (words.length > 1) {
        var whileCount = Math.floor(words.length / 2);          
        var resultCode = "";
        for(var i = 0; i < whileCount * 2; i+=2) {
          resultCode += words[i] + words[i + 1] + injectedCheckFunctionCall 
        }

        resultCode += words[i].substring(0, words[i].length - 2) 
            + injectedCheckFunction
            + "})";
        sketch.sourceCode = resultCode;
        sketch.onFrameStart = function () {window.ki_starLoopTime = Date.now();};
      }

      // for loop
      var words = sketch.sourceCode.split(/(for\s*\(.*\)\s*{)/g);
      
      if (words.length > 1) {
        var whileCount = Math.floor(words.length / 2);          
        var resultCode = "";
        for(var i = 0; i < whileCount * 2; i+=2) {
          resultCode += words[i] + words[i + 1] + injectedCheckFunctionCall 
        }

        resultCode += words[i].substring(0, words[i].length - 2) 
            + injectedCheckFunction
            + "})";
        sketch.sourceCode = resultCode;
        sketch.onFrameStart = function () {window.ki_starLoopTime = Date.now();};
      }      
    //   sketch = Processing.compile(codeValue);
      var instance = new Processing(canvas, sketch);
      // instance.loop();
      window.isErrorInSketch = false;
    //   $('#mouseCoords').html("");
    document.getElementById("mouseCoords").innerHTML = "";

      // setTimeout(instance.noLoop, 1000);
    } catch (e) {
      // output.value = "Error! Error was:\n" + e.toString();
      window.isErrorInSketch = true;
      console.log("ERROR: " + e.toString());
      document.getElementById("mouseCoords").innerHTML = e.toString();
    //   $('#mouseCoords').html(getRandomSadSmile() + e.toString()); // "😵"
    }
  }

  window.onerror = function(error, url, line, column, errorObj) {
    console.log('we error: ' + error + ' url: ' + url + ' line: ' + line
      + ' Column: ' + column + ' StackTrace: ' +  errorObj);
    // $('#mouseCoords').html('we: ' + error);
    let mc = document.getElementById("mouseCoords");
    if (mc) mc.innerHTML = error.toString();
    window.isErrorInSketch = true;
  };

  export {runSketch, createCanvas}